import card_img1 from './card1.jpg';
import card_img2 from './card2.jpg';
import card_img3 from './card3.jpg';
import card_img4 from './card4.jpg';
import card_img5 from './card5.jpg';
import card_img6 from './card6.jpg';
import card_img7 from './card7.jpg';
import card_img8 from './card8.jpg';
import card_img9 from './card9.jpg';
import card_img10 from './card10.jpg';
import card_img11 from './card11.jpg';
import card_img12 from './card12.jpg';
import card_img13 from './card13.jpg';
import card_img14 from './card14.jpg';

const cards_data = [
    {
        image:card_img1,
        name:"Kung Fu Panda"
    },
    {
        image:card_img2,
        name:"Squid Game"
    },
    {
        image:card_img3,
        name:"Squid Challange"
    },
    {
        image:card_img4,
        name:"Jawan"
    },
    {
        image:card_img5,
        name:"The Ghost"
    },
    {
        image:card_img6,
        name:"Lucifer"
    },
    {
        image:card_img7,
        name:"The Railway MEN"
    },
    {
        image:card_img8,
        name:"Young Sheldon"
    },
    {
        image:card_img9,
        name:"Sacred Games"
    },
    {
        image:card_img10,
        name:"Adipurush"
    },
    {
        image:card_img11,
        name:"Sukhee"
    },
    {
        image:card_img12,
        name:"Mission Ganj"
    },
    {
        image:card_img13,
        name:"Leo"
    },
    {
        image:card_img14,
        name:"All of Us Are Dead"
    },
]

export default cards_data;